// Web implementation — uses localStorage
export const storage = {
  get: (key: string): Promise<string | null> => Promise.resolve(localStorage.getItem(key)),
  set: (key: string, value: string): Promise<void> => {
    localStorage.setItem(key, value)
    return Promise.resolve()
  },
  remove: (key: string): Promise<void> => {
    localStorage.removeItem(key)
    return Promise.resolve()
  },
}
